/* eslint @typescript-eslint/no-explicit-any: 0 */

import { useEffect } from 'react';

import Icon from '~/legacy/components/Icon';
import mainHeaderMenu from '~/legacy/data/main-mobile-data';
import { useModal } from '~/legacy/hooks/useModal';
import type { MobileHeaderProps } from '~/legacy/types';
import { bem } from '~/legacy/utils';

import MainHeaderMobile from './MainHeaderMobile';

const MenuModal = ({
  mobileMenuIsOpen,
  setMobileMenuIsOpen
}: MobileHeaderProps) => {
  const [isOpen, setOpen, setClosed]: [boolean, any, any] = useModal();

  useEffect(() => {
    mobileMenuIsOpen && setOpen && setOpen();
  }, [mobileMenuIsOpen, setOpen]);

  return (
    <div className="burger-menu">
      <div
        className="burger-menu__burger-holder"
        onClick={() => {
          setMobileMenuIsOpen(!mobileMenuIsOpen);
        }}
      >
        {!isOpen && (
          <Icon
            name="burger"
            className="burger-menu__burger-button"
            width="19"
            height="19"
            viewBox="0 0 30 30"
            fill="#ffffff"
          />
        )}
      </div>

      <div className={bem('burger-menu', [isOpen ? 'show' : 'hide'])}>
        <MainHeaderMobile
          menu={mainHeaderMenu?.TSS}
          setClosed={setClosed}
          setMobileMenuIsOpen={setMobileMenuIsOpen}
          mobileMenuIsOpen={mobileMenuIsOpen}
        />

        <div className="burger-menu__close-icon">
          <Icon
            onClick={() => {
              setClosed();
              setMobileMenuIsOpen(!mobileMenuIsOpen);
            }}
            name="close"
            width="18"
            height="18"
            viewBox="0 0 1792 1792"
            fill="#4D4D4F"
          />
        </div>
      </div>
    </div>
  );
};

export default MenuModal;
